"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_VARIANT = void 0;
exports.EMPTY_VARIANT = {
    name: "disabled",
    enabled: false,
};
//# sourceMappingURL=constants.js.map